import React, { useEffect, useState } from 'react'
import { Button, Col, Container, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap'
import { Form, useSubmit } from 'react-router-dom'
import { Usuario } from '../Interfaces/Interfaces'
import Menu from '../Componentes/Menu';
import { MenuItems } from '../Componentes/MenuItems';
import { AdvancedMarker, APIProvider, Map, Marker, useMarkerRef } from '@vis.gl/react-google-maps';



interface Props{
  hamburguesa:boolean;
  setToolbar:(isActive:boolean)=>void;
  isLogin:boolean;
  }
//let initialState:Usuario = {"usuario":"","rut":"","nombre":"","clave":"","apellido":""}
export const Mapa = (props:Props) => {
    //const [usuario, setUsuario] = useState<Usuario>(initialState);
    const [markerRef, marker] = useMarkerRef();
    const handleChange = (value:string,name:string)=>{
        console.log(value);
        console.log(name);

    }
    const registrar = ()=>{
            console.log("REgistrando")
    }
    useEffect(()=>{
        props.setToolbar(true);
    },[])
    
return (
  <Row>
    <Menu key="menu1" menu={props.hamburguesa}>
      <MenuItems/>
    </Menu>
    <Col style={{backgroundColor:'red'}}>
    <Container>
    <APIProvider apiKey={"AIzaSyCwYMHsIR3WvrcnuBVu4Yu96KtZRJe3J5s"}>
    <Map
      style={{width: '50vh', height:'50vh'}}
      defaultCenter={{lat: -27.3973092, lng: -70.3128354}}
      defaultZoom={3}
      gestureHandling={'greedy'}
      disableDefaultUI={true}
    >
      <Marker ref={markerRef} position={{lat: -27.3973092, lng: -70.3128354}} 
      clickable={true}
      onClick={()=>{console.log("HOLA")}}/>
    
      </Map>
  </APIProvider>
  </Container>
    </Col>
    </Row>
  )
}
